module.exports = __webpack_public_path__ + "static/media/kaaba.9196ebf5.svg";